<template>
  <v-expansion-panels accordion>
    <v-expansion-panel>
      <v-expansion-panel-header><b>Charts</b></v-expansion-panel-header>
      <v-expansion-panel-content>
          <v-overlay
            :absolute="true"
            :value="loading"
          >
            <div
              class="loader pa-4 d-flex flex-column justify-center align-center"
            >
              <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="primary"
              />
              <div>Waiting for information for charts</div>
            </div>
        </v-overlay>
        <v-row>
          <template v-for="chart in charts" >
            <v-col cols="4" v-if="chart.series.length" :key="chart.title">
              <ConfigSettingsChart
                :title="chart.title"
                :series="chart.series"
                :categories="chart.categories"
              />
            </v-col>
          </template>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import ConfigSettingsChart from './configSettingsChart.vue'
export default {
  components: {
    ConfigSettingsChart
  },
  data () {
    return {
      loading: false,
      charts: [],
    }
  },
  async mounted () {
    await this.getData()
  },
  watch: {
    async '$route.query' () {
      await this.getData()
    }
  },
  methods: {
    async getData () {
      if (!this.$route.query.build_id) {
        return
      }

      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/telemetry/config-settings/charts`, {
          params: {
            build_id: this.$route.query.build_id
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.charts = data
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.v-overlay >>> .v-overlay__content {
  top: 64px;
  position: absolute;
}

.v-overlay >>> .loader {
  min-width: 100px;
}
</style>